// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableContainer {
  height: 740px;
  margin: 0 5%;
  margin-bottom: 20px;
  overflow-y: auto;
}

.backlogTable {
  height: 720px;
  overflow-y: auto;
  display: block;
  border-spacing: 0px;
}

.backlogTable tbody tr:hover {
  background-color: #cae0ee;
}

.backlogTable tbody tr:active {
  background-color: #71b9e9 !important;
}
.backlogTable tbody tr:visited {
  background-color: #71b9e9 !important;
}

.backlogTable thead tr th {
  text-align: center;
  padding: 10px;
  position: sticky;
  top: 0px;
  background-color: #e5e5e5;
  color: #797979;
  width: 172px;
}

.backlogTable tbody tr td {
  text-align: center;
  padding: 10px;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  cursor: pointer;
  color: #797979;
  border-bottom: 2px solid #e5e5e5 !important;
}

.backlogTable thead tr th:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.questionId,  .backlogDeleteTh {
  width: 14% !important;
}

.backlogRejectTh{
  width: 26.6% !important;
}

.backlogImageContainer {
  height: 510px;
  display: flex;
  margin: 0 10%;
  justify-content: center;
}

.backlogImage {
  margin-right: 5%;
  width: 200px;
  height: 200px;
  border-radius: 10px;
}

.backlogDeleteBtn {
  max-height: 30px;
  color: #f2f2f2;
  font-size: 13px;
  border-radius: 4px;
  border: none;
  padding: 8px 15px;
  background: #68dff0;
  cursor: pointer;
  margin-bottom: 5px;
}

.backlogDeleteBtn:hover {
  background-color: #51cac2;
}

.backlogDeleteBtn:active {
  border: 1px solid #03afa9 !important;
}

.backlogButton {
  max-height: 35px;
  margin-top: 82px;
  color: #f2f2f2;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  padding: 8px 15px;
  background: #68dff0;
  cursor: pointer;
}

.backlogButton:hover {
  background-color: #51cac2;
}

.backlogButton:active {
  border: 1px solid #03afa9 !important;
}

.backlogTableButton {
  max-height: 45px;
  margin-top: 0px;
  color: #f2f2f2;
  font-size: 13px;
  border-radius: 4px;
  border: none;
  padding: 8px 15px;
  background: #68dff0;
  cursor: pointer;
}
.backlogTableButton:hover {
  background-color: #51cac2;
}

.backlogTableButton:active {
  border: 1px solid #03afa9 !important;
}

.backlogBigImage {
  width: 100%;
  height: 500px;
  border-radius: 10px;
  margin-top: 25px;
}

.queSubContainerBacklog {
  background-color: white;
  padding: 15px;
  padding-bottom: 30px;
  margin-bottom: 15px;
  box-shadow: 0px 3px 2px #aab2bd;
}

.paginationContainerBacklog {
  display: flex;
  justify-content: center;
  margin-top: 25px;
  margin-bottom: 20px;
}

.peginationNumberDiv {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/Screens/Backlog/backlog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".tableContainer {\n  height: 740px;\n  margin: 0 5%;\n  margin-bottom: 20px;\n  overflow-y: auto;\n}\n\n.backlogTable {\n  height: 720px;\n  overflow-y: auto;\n  display: block;\n  border-spacing: 0px;\n}\n\n.backlogTable tbody tr:hover {\n  background-color: #cae0ee;\n}\n\n.backlogTable tbody tr:active {\n  background-color: #71b9e9 !important;\n}\n.backlogTable tbody tr:visited {\n  background-color: #71b9e9 !important;\n}\n\n.backlogTable thead tr th {\n  text-align: center;\n  padding: 10px;\n  position: sticky;\n  top: 0px;\n  background-color: #e5e5e5;\n  color: #797979;\n  width: 172px;\n}\n\n.backlogTable tbody tr td {\n  text-align: center;\n  padding: 10px;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  cursor: pointer;\n  color: #797979;\n  border-bottom: 2px solid #e5e5e5 !important;\n}\n\n.backlogTable thead tr th:first-child {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.questionId,  .backlogDeleteTh {\n  width: 14% !important;\n}\n\n.backlogRejectTh{\n  width: 26.6% !important;\n}\n\n.backlogImageContainer {\n  height: 510px;\n  display: flex;\n  margin: 0 10%;\n  justify-content: center;\n}\n\n.backlogImage {\n  margin-right: 5%;\n  width: 200px;\n  height: 200px;\n  border-radius: 10px;\n}\n\n.backlogDeleteBtn {\n  max-height: 30px;\n  color: #f2f2f2;\n  font-size: 13px;\n  border-radius: 4px;\n  border: none;\n  padding: 8px 15px;\n  background: #68dff0;\n  cursor: pointer;\n  margin-bottom: 5px;\n}\n\n.backlogDeleteBtn:hover {\n  background-color: #51cac2;\n}\n\n.backlogDeleteBtn:active {\n  border: 1px solid #03afa9 !important;\n}\n\n.backlogButton {\n  max-height: 35px;\n  margin-top: 82px;\n  color: #f2f2f2;\n  font-size: 14px;\n  border-radius: 4px;\n  border: none;\n  padding: 8px 15px;\n  background: #68dff0;\n  cursor: pointer;\n}\n\n.backlogButton:hover {\n  background-color: #51cac2;\n}\n\n.backlogButton:active {\n  border: 1px solid #03afa9 !important;\n}\n\n.backlogTableButton {\n  max-height: 45px;\n  margin-top: 0px;\n  color: #f2f2f2;\n  font-size: 13px;\n  border-radius: 4px;\n  border: none;\n  padding: 8px 15px;\n  background: #68dff0;\n  cursor: pointer;\n}\n.backlogTableButton:hover {\n  background-color: #51cac2;\n}\n\n.backlogTableButton:active {\n  border: 1px solid #03afa9 !important;\n}\n\n.backlogBigImage {\n  width: 100%;\n  height: 500px;\n  border-radius: 10px;\n  margin-top: 25px;\n}\n\n.queSubContainerBacklog {\n  background-color: white;\n  padding: 15px;\n  padding-bottom: 30px;\n  margin-bottom: 15px;\n  box-shadow: 0px 3px 2px #aab2bd;\n}\n\n.paginationContainerBacklog {\n  display: flex;\n  justify-content: center;\n  margin-top: 25px;\n  margin-bottom: 20px;\n}\n\n.peginationNumberDiv {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
